import * as THREE from 'three'
import { hideBakedDirectionSigns } from '../../Utils/hideBakedExperiencesSign.js'
import { createDirectionSign, createSignPostCollision } from '../../Utils/createDirectionSign.js'

export default class CrossroadsSection
{
    constructor(_options)
    {
        // Options
        this.time = _options.time
        this.resources = _options.resources
        this.objects = _options.objects
        this.areas = _options.areas
        this.tiles = _options.tiles
        this.debug = _options.debug
        this.x = _options.x
        this.y = _options.y

        // Set up
        this.container = new THREE.Object3D()
        this.container.matrixAutoUpdate = false

        hideBakedDirectionSigns(this.resources)
        this.setStatic()
        this.setSigns()
        this.setTiles()
    }

    setSigns()
    {
        const experiencesSign = createDirectionSign({
            label: 'Projects',
            materials: this.objects.materials,
            position: new THREE.Vector3(this.x + 8.91, this.y, 0),
            pointAt: new THREE.Vector3(- 22, - 52, 0),
            reverse: true,
        })
        this.container.add(experiencesSign)

        const contactSign = createDirectionSign({
            label: 'Contact',
            materials: this.objects.materials,
            position: new THREE.Vector3(this.x + 0.04, this.y - 8.98, 0),
            pointAt: new THREE.Vector3(1.2, - 55, 0),
        })
        this.container.add(contactSign)

        const projectsPosition = new THREE.Vector3(- 20, - 40, 0)
        const projectsSign = createDirectionSign({
            label: 'Experiences',
            materials: this.objects.materials,
            position: projectsPosition,
            pointAt: new THREE.Vector3(30, - 30, 0),
            reverse: true,
        })
        this.container.add(projectsSign)

        this.objects.add({
            base: new THREE.Object3D(),
            collision: createSignPostCollision(projectsPosition),
            offset: new THREE.Vector3(0, 0, 0),
            mass: 0,
        })
    }

    setStatic()
    {
        this.objects.add({
            base: this.resources.items.crossroadsStaticBase.scene,
            collision: this.resources.items.crossroadsStaticCollision.scene,
            floorShadowTexture: this.resources.items.crossroadsStaticFloorShadowTexture,
            offset: new THREE.Vector3(this.x, this.y, 0),
            mass: 0
        })
    }

    setTiles()
    {
        // To intro
        this.tiles.add({
            start: new THREE.Vector2(this.x, - 10),
            delta: new THREE.Vector2(0, this.y + 14)
        })

        // To projects
        this.tiles.add({
            start: new THREE.Vector2(this.x + 12.5, this.y),
            delta: new THREE.Vector2(7.5, 0)
        })

        // To playground
        this.tiles.add({
            start: new THREE.Vector2(this.x - 13, this.y),
            delta: new THREE.Vector2(- 6, 0)
        })

        // To experiences — ends where the first experience billboard starts
        this.tiles.add({
            start: new THREE.Vector2(this.x - 9, this.y - 7),
            delta: new THREE.Vector2(- 13, - 15)
        })
    }
}
